var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgInfoOutline = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 25,
  height: 24,
  viewBox: "0 0 25 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "info_outline",
  clipPath: "url(#clip0_1978_6167)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M11.4536 7H13.4536V9H11.4536V7ZM12.4536 17C13.0036 17 13.4536 16.55 13.4536 16V12C13.4536 11.45 13.0036 11 12.4536 11C11.9036 11 11.4536 11.45 11.4536 12V16C11.4536 16.55 11.9036 17 12.4536 17ZM12.4536 2C6.93361 2 2.45361 6.48 2.45361 12C2.45361 17.52 6.93361 22 12.4536 22C17.9736 22 22.4536 17.52 22.4536 12C22.4536 6.48 17.9736 2 12.4536 2ZM12.4536 20C8.04361 20 4.45361 16.41 4.45361 12C4.45361 7.59 8.04361 4 12.4536 4C16.8636 4 20.4536 7.59 20.4536 12C20.4536 16.41 16.8636 20 12.4536 20Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1978_6167"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white",
  transform: "translate(0.453613)"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgInfoOutline);
export { ForwardRef as ReactComponent };